import { FC, useRef, useEffect, useState } from "react";
import { useDataTableStore } from "../../../stores/DataTableStore";
import { useFormik } from "formik";
import * as Yup from 'yup';
import Swal from "sweetalert2";
import clsx from "clsx";
import useAccessToken from "../../../hooks/AccessToken";
import { KTSVG } from "../../../_metronic/helpers";
import { handleCaps } from "../../../functions/general";
import { Pipeline, TemplatePipelineProps } from "../../../interfaces/Pipeline";
import { TableColumn } from "react-data-table-component";
import { useIntl } from "react-intl";
import useHandleCloseModal from "../../../hooks/HandleCloseModal";
import { useTemplatePipeline } from "../../../stores/TemplatePipeline";
import { insertTemplatePipeline, updateTemplatePipeline } from "../../../api/PipelineCRUD";
import { usePipelineStore } from "../../../stores/PipelineStore";
import { Modal } from "rsuite";

interface ModifyTemplateProps {
    type: string
    manageColumns: TableColumn<Pipeline>[]
    template: TemplatePipelineProps
    isOpen: boolean
    onClose: () => void
}

const ModifyTemplate: FC<ModifyTemplateProps> = ({ type, manageColumns, template, isOpen, onClose }) => {
    const token = useAccessToken()
    const intl = useIntl()
    const { selectedFilters, masterDateRange, typeDateFilter } = useDataTableStore();
    const { selectMultiPipeline } = usePipelineStore()
    const { userTemplatePipeline, companyTemplatePipeline, setUserTemplatePipeline, setCompanyTemplatePipeline } = useTemplatePipeline()
    const closeModalRef = useRef<HTMLButtonElement>(null);
    const modalRef = useRef<HTMLDivElement | null>(null);
    const [modalBtnLoading, setModalBtnLoading] = useState(false);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.TEMPLATE_NAME" }) })),
    });

    const initialValues = {
        name: type === 'update-template-user' || type === 'update-template-company' ? template.name : '',
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            setModalBtnLoading(true);
            setSubmitting(true);
            var dataTemplate = {}
            if (type === 'insert-template-user' || type === 'insert-template-company') {
                var dataSort: string[] = []
                var dataHide: string[] = []
                manageColumns.map(item => {
                    dataSort.push(item.id as string);

                    if (item.omit === true) {
                        dataHide.push(item.id as string);
                    }
                });

                dataTemplate = {
                    hide: dataHide,
                    sort: dataSort,
                    use: false,
                    filter: {
                        leadProducts: [...selectedFilters['pipelines'].leadProducts],
                        lead_progress_name: [...selectedFilters['pipelines'].lead_progress_name],
                        lead_subprogress_name: [...selectedFilters['pipelines'].lead_subprogress_name],
                        lead_progress_progress_type: [...selectedFilters['pipelines'].lead_progress_progress_type],
                        owner_name: [...selectedFilters['pipelines'].owner_name],
                        leadProductLabels: [...selectedFilters['pipelines'].leadProductLabels],
                        labels: [...selectedFilters['pipelines'].labels],
                        lead_source_name: [...selectedFilters['pipelines'].lead_source_name],
                        creator_name: [...selectedFilters['pipelines'].creator_name],
                        unitNames: [...selectedFilters['pipelines'].unitNames]
                    },
                    filter_date_range: {
                        typeDateFilter: typeDateFilter,
                        startDate: masterDateRange.pipeline?.startDate,
                        endDate: masterDateRange.pipeline?.endDate
                    }
                }
            } else if (type === 'update-template-user' || type === 'update-template-company') {
                dataTemplate = { ...template.content, use: false }
            }
            try {
                var response: any = {}
                const positionUserTemplate = userTemplatePipeline.length + 1
                const positionCompanyTemplate = companyTemplatePipeline.length + 1
                if (type === 'insert-template-user') response = await insertTemplatePipeline('user', selectMultiPipeline.id, values.name, JSON.stringify(dataTemplate), positionUserTemplate, token)
                else if (type === 'insert-template-company') response = await insertTemplatePipeline('company', selectMultiPipeline.id, values.name, JSON.stringify(dataTemplate), positionCompanyTemplate, token)
                else if (type === 'update-template-user' || type === 'update-template-company') response = await updateTemplatePipeline(template.id, selectMultiPipeline.id, values.name, JSON.stringify(dataTemplate), token)

                if (response.data.success) {
                    Swal.fire({
                        icon: 'success',
                        heightAuto: false,
                        title: intl.formatMessage({ id: "FORM.VALIDATION.SAVE_SUCCESS" }),
                        timer: 2000,
                        timerProgressBar: true
                    })

                    var dataUpdateUserTemplate = userTemplatePipeline.map((data: TemplatePipelineProps) => ({
                        ...data,
                        content: {
                            ...data.content,
                            use: false,
                        }
                    }))
                    var dataUpdateCompanyTemplate = companyTemplatePipeline.map((data: TemplatePipelineProps) => ({
                        ...data,
                        content: {
                            ...data.content,
                            use: false,
                        }
                    }))

                    if (type === 'insert-template-user') {
                        setCompanyTemplatePipeline([...dataUpdateCompanyTemplate])
                        setUserTemplatePipeline([...dataUpdateUserTemplate, {
                            ...response.data.data,
                            content: {
                                ...dataTemplate,
                                use: true
                            }
                        }]);
                    } else if (type === 'update-template-user') {
                        setUserTemplatePipeline(userTemplatePipeline.map(item => {
                            if (item.id === template.id) {
                                return {
                                    ...item,
                                    name: values.name,
                                }
                            } else {
                                return item
                            }
                        }));
                    } else if (type === 'insert-template-company') {
                        setUserTemplatePipeline([...dataUpdateUserTemplate])
                        setCompanyTemplatePipeline([...dataUpdateCompanyTemplate, {
                            ...response.data.data,
                            content: {
                                ...dataTemplate,
                                use: true
                            }
                        }]);
                    } else if (type === 'update-template-company') {
                        setCompanyTemplatePipeline(companyTemplatePipeline.map(item => {
                            if (item.id === template.id) {
                                return {
                                    ...item,
                                    name: values.name,
                                }
                            } else {
                                return item
                            }
                        }));
                    }

                    formik.resetForm();
                    onClose()
                }
            } catch (error: any) {
                Swal.fire({
                    icon: 'error',
                    title: error.response.data.message,
                    confirmButtonText: 'Ok'
                });
            } finally {
                setModalBtnLoading(false);
                setSubmitting(false);
            }
        },
    });

    const handleCloseModal = () => {
        if (formik.values.name !== '') {
            Swal.fire({
                title: intl.formatMessage({ id: 'FORM.VALIDATION.CANCEL' }),
                text: intl.formatMessage({ id: 'FORM.VALIDATION.DESC_CANCEL' }),
                icon: 'warning',
                showCancelButton: !0,
                buttonsStyling: !1,
                confirmButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.YES' }) + ", " + intl.formatMessage({ id: 'FORM.ACTION.CANCEL' }),
                cancelButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.NO' }),
                customClass: {
                    confirmButton: "btn btn-danger",
                    cancelButton: "btn btn-active-light me-3",
                },
                reverseButtons: true,
                heightAuto: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    onClose()
                }
            });
        } else {
            onClose()
        }
    }

    useEffect(() => {
        const getRsModalWrapper: HTMLDivElement | null = document.querySelector('.rs-modal-wrapper')
        if (getRsModalWrapper) {
            getRsModalWrapper.style.display = 'flex'
            getRsModalWrapper.style.alignItems = 'center'
            getRsModalWrapper.style.justifyContent = 'center'
        }
    }, [])

    return (
        <Modal
            backdrop={true}
            keyboard={false}
            open={isOpen}
            onClose={handleCloseModal}
            size="sm"
        >
            <Modal.Header>
                <h5 className="modal-title">{type === 'update-template-user' || type === 'update-template-company' ? `${intl.formatMessage({ id: 'FORM.ACTION.UPDATE' })} ${intl.formatMessage({ id: 'FILTER.LABEL.DATABASE' })} ${template.name}` : `${intl.formatMessage({ id: 'FORM.ACTION.ADD' })} ${intl.formatMessage({ id: 'FILTER.LABEL.DATABASE' })}`}</h5>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={formik.handleSubmit} noValidate>
                    <div className="modal-body">
                        {formik.status && (
                            <div className='mb-lg-15 alert alert-danger'>
                                <div className='alert-text font-weight-bold'>{formik.status}</div>
                            </div>
                        )}
                        <label className='form-label fs-6 fw-bolder text-dark required'>{intl.formatMessage({ id: 'FORM.LABEL.TEMPLATE_NAME' })}</label>
                        <div className="input-group mb-3">
                            <input
                                id="name"
                                placeholder='Nama'
                                {...formik.getFieldProps('name')}
                                className={clsx(
                                    'form-control form-control-lg',
                                    { 'is-invalid': formik.touched.name && formik.errors.name },
                                )}
                                type='text'
                                name='name'
                                autoComplete='off'
                                onInput={(e) => handleCaps(e)}
                            />
                        </div>
                        {formik.touched.name && formik.errors.name && (
                            <div className='fv-plugins-message-container text-danger'>
                                <span role='alert' className="text-danger">{formik.errors.name}</span>
                            </div>
                        )}
                    </div>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn btn-light me-3"
                            onClick={handleCloseModal}
                        >
                            {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                        </button>
                        <button type="submit" className={`btn btn-primary me-10 ${modalBtnLoading ? "disabled" : ""}`} data-kt-indicator={modalBtnLoading ? 'on' : 'off'}>
                            <span className="indicator-label">
                                {intl.formatMessage({ id: "FORM.ACTION.SAVE" })}
                            </span>
                            <span className="indicator-progress">
                                Loading... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export { ModifyTemplate }